module.exports = [
    { id : 'ACTIVE', label: 'Active' },
    { id : 'INACTIVE', label: 'Inactive' },
    { id : 'ACCEPTED', label: 'Accepted' },
    { id : 'PENDING', label: 'Pending' },    
    { id : 'DECLINED', label: 'Declined' }
];
